export const SIZE_PAGINATION = [
    {
        name: "5",
        value: 5
    },
    {
        name: "10",
        value: 10
    },
    {
        name: "25",
        value: 25
    },
    {
        name: "50",
        value: 50
    },
    {
        name: "100",
        value: 100
    },
];

export const DEFAULT_PAGINATION = {
    size: 10,
    page: 1
}